import React from 'react';
import { Icon, Text } from '@chakra-ui/react';

import { Link, RoutePath } from './routes';
import { LinkProps } from './createLink';
import { Destination } from './types';
import { TbArrowLeft } from 'react-icons/tb';

type Props<T extends string> = LinkProps & {
  to: Destination<T>;
  text?: string;
};

export function BackLink<T extends RoutePath>(props: Props<T>) {
  const { text, ...otherProps } = props;
  return (
    <Link
      back
      display="flex"
      alignItems="center"
      color="gray.500"
      textDecoration="none"
      {...otherProps}
    >
      <Icon as={TbArrowLeft} fontSize={16} />
      <Text ml={1}>{text ?? t('Back')}</Text>
    </Link>
  );
}
